export enum LogoLayoutType {
    PropertyLogoOnly = 0,
    CompanyLogoOnly,
    CompanyLogoPropertyLogo,
    CompanyLogoPropertyName
}
